module.exports = __webpack_public_path__ + "img/amazon.b86664f2.svg";